// What the Brimstone addon records from 0.4.0 (M11) besides facts and events: groups, time and
// gold and loot per session and zone, auction mail. Stored as JSON on GroupSession and
// ActivityBucket rows.
import type { IsoDateString } from './api/common';

/** One member of a group: when they were first and last in it (`to` null while still there). */
export type GroupMemberValue = {
  /** "First Last", as Forever names players. */
  name: string;
  /** Class token: WARRIOR, PRIEST… */
  class: string | null;
  level: number | null;
  from: IsoDateString;
  to: IsoDateString | null;
};

/** What was open when gold changed hands; `repair` is a merchant's repair bill (addon 0.4.1). */
export const MONEY_CATEGORIES = [
  'loot',
  'quest',
  'merchant',
  'repair',
  'auction',
  'mail',
  'trainer',
  'taxi',
  'trade',
  'other',
] as const;
export type MoneyCategory = (typeof MONEY_CATEGORIES)[number];

/** Copper gained and spent, by category. */
export type ActivityMoney = Partial<Record<MoneyCategory, { gain: number; spend: number }>>;

/** Where a loot window's contents came from. */
export const LOOT_SOURCES = [
  'creature',
  'herb',
  'ore',
  'skin',
  'fishing',
  'object',
  'item',
  'other',
] as const;
export type LootSource = (typeof LOOT_SOURCES)[number];

/** Loot windows opened and items looted (itemID → count), by source. */
export type ActivityLoot = Partial<
  Record<LootSource, { n: number; items: Record<string, number> }>
>;

export type AuctionMailKind = 'sold' | 'bought' | 'expired';
